export function getText(value) {
  let sort = ''
  if (value.due_date) {
    sort = `Due date (${value.due_date === 'desc' ? `Latest first` : `Earliest first`})`
  }
  if (value.priority) {
    sort = `Priority (${value.priority === 'desc' ? `Highest first` : `Lowest first`})`
  }
  if (value.created_at) {
    sort = `Created date (${value.created_at === 'desc' ? `Most recent first` : `Oldest first`})`
  }

  return `Sorted by: ${sort}`
}
